import { useQuery } from "@tanstack/react-query";
import { BudgetResponse, GetBudgetResolutionEnum } from "@norma-bi/bi-api";
import { useRootAPI } from "@/api";

export function useGetBudget(
  businessId: string | undefined,
  resolution: GetBudgetResolutionEnum,
  year: number,
) {
  const rootAPI = useRootAPI();

  return useQuery<BudgetResponse, Error>({
    queryKey: ["budget", businessId, resolution, year],
    queryFn: async () => {
      return await rootAPI.getBudget({
        business_id: businessId!,
        resolution,
        year,
      });
    },
    enabled: Boolean(businessId),
  });
}
